import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BlogPost2() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <Link to="/blog" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
              <i className="ri-arrow-left-line"></i>
              <span className="font-medium">Blog'a Dön</span>
            </Link>
            
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
              <span className="text-sm font-medium text-teal-400">Fiber Optik</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              OTDR Testi Nedir? Fiber Optik Arıza Tespitinde Kullanımı
            </h1>
            
            <div className="flex flex-wrap items-center gap-4 text-slate-300">
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  <span>12 Mayıs 2024</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  <span>7 dakika okuma</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-folder-line"></i>
                  <span>Fiber Optik</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-12 bg-slate-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/1a2fe14cc03d919be2d9e9bbfa196104.jpg"
                alt="OTDR Testi"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              
              <p className="text-xl text-slate-700 leading-relaxed mb-8 font-medium">
                OTDR (Optical Time Domain Reflectometer - Optik Zaman Alanı Reflektometresi), fiber optik kablolardaki arızaları tespit etmek, ek kalitesini ölçmek ve fiber performansını analiz etmek için kullanılan en gelişmiş test cihazıdır. İstanbul, Gebze, Kocaeli ve çevre illerdeki sanayi tesislerinde fiber altyapı kurulumu ve bakımında vazgeçilmez bir araçtır.
              </p>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR Nedir ve Nasıl Çalışır?</h2>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                OTDR, fiber optik kabloya ışık darbeleri göndererek, bu ışığın fiber boyunca yansımasını ve geri dönüşünü ölçen bir test cihazıdır. Çalışma prensibi radar teknolojisine benzer:
              </p>

              <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-8 rounded-2xl mb-8 border border-teal-100">
                <h3 className="text-xl font-bold text-slate-900 mb-4">OTDR Çalışma Prensibi:</h3>
                <ol className="space-y-4 text-slate-700">
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">1</span>
                    <div>
                      <strong className="block mb-1">Işık Darbesi Gönderimi:</strong>
                      <span>OTDR cihazı fiber kabloya kısa süreli yüksek güçlü ışık darbeleri gönderir (genellikle 1310 nm veya 1550 nm dalga boyunda)</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">2</span>
                    <div>
                      <strong className="block mb-1">Rayleigh Saçılması:</strong>
                      <span>Işık fiber boyunca ilerlerken, cam moleküllerinden sürekli olarak geri saçılır (backscatter)</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">3</span>
                    <div>
                      <strong className="block mb-1">Yansıma Tespiti:</strong>
                      <span>Ek noktaları, konnektörler ve arızalar güçlü yansımalar (reflection) oluşturur</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">4</span>
                    <div>
                      <strong className="block mb-1">Zaman Ölçümü:</strong>
                      <span>Geri dönen ışığın zamanı ölçülerek, olayın fiber üzerindeki konumu hesaplanır</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">5</span>
                    <div>
                      <strong className="block mb-1">Grafik Oluşturma:</strong>
                      <span>Tüm veriler birleştirilerek OTDR trace (iz) grafiği oluşturulur</span>
                    </div>
                  </li>
                </ol>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR Trace Grafiği Nasıl Okunur?</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                OTDR test sonucu bir grafik (trace) olarak görüntülenir. Bu grafikte:
              </p>

              <div className="space-y-6 mb-8">
                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">X Ekseni (Yatay)</h4>
                      <p className="text-slate-700 text-sm leading-relaxed">
                        Mesafeyi gösterir (metre veya kilometre cinsinden). Fiber kablonun başlangıcından itibaren uzaklık.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-up-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Y Ekseni (Dikey)</h4>
                      <p className="text-slate-700 text-sm leading-relaxed">
                        Güç seviyesini gösterir (dB cinsinden). Yukarıdan aşağıya doğru güç azalır, bu normal fiber kaybıdır.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-line-chart-line text-2xl text-teal-600"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Eğim (Slope)</h4>
                      <p className="text-slate-700 text-sm leading-relaxed">
                        Grafiğin genel eğimi fiber kablonun doğal kaybını (attenuation) gösterir. Tipik değer: 0.2-0.4 dB/km
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">OTDR Trace'de Görülen Olaylar</h3>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                      <i className="ri-checkbox-circle-line text-xl text-green-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Fusion Splice (Kaynaklı Ek)</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed mb-2">
                    Grafikte küçük bir düşüş olarak görünür. Kaliteli bir fusion splice 0.02-0.05 dB kayıp gösterir.
                  </p>
                  <p className="text-slate-600 text-xs">
                    ✓ Yansıma yok veya çok düşük
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <i className="ri-plug-line text-xl text-blue-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Konnektör</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed mb-2">
                    Grafikte ani bir düşüş ve yukarı doğru bir pik (yansıma) görünür. Tipik kayıp: 0.3-0.5 dB
                  </p>
                  <p className="text-slate-600 text-xs">
                    ⚠ Yüksek yansıma var
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-arrow-right-down-line text-xl text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Makro Bükülme</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed mb-2">
                    Fiberin aşırı bükülmesi durumunda grafikte ani kayıp görünür. Bükülme açısı arttıkça kayıp artar.
                  </p>
                  <p className="text-slate-600 text-xs">
                    ⚠ Fiziksel düzeltme gerekli
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                      <i className="ri-close-circle-line text-xl text-red-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Kırık/Kesik</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed mb-2">
                    Grafikte ani ve tam bir düşüş görünür. Sinyal tamamen kesilir ve fiber sonu olarak algılanır.
                  </p>
                  <p className="text-slate-600 text-xs">
                    ✗ Acil tamir gerekli
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR Test Parametreleri</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                Doğru OTDR testi için uygun parametrelerin seçilmesi kritik önem taşır:
              </p>

              <div className="bg-slate-50 border-l-4 border-teal-500 p-6 rounded-r-xl mb-8">
                <h4 className="font-bold text-slate-900 mb-4">Temel OTDR Parametreleri:</h4>
                <div className="space-y-4">
                  <div>
                    <h5 className="font-semibold text-slate-900 mb-1">Dalga Boyu (Wavelength)</h5>
                    <p className="text-slate-700 text-sm leading-relaxed">
                      <strong>Single Mode:</strong> 1310 nm (kısa mesafe) ve 1550 nm (uzun mesafe)<br />
                      <strong>Multi Mode:</strong> 850 nm ve 1300 nm<br />
                      Her iki dalga boyunda da test yapılması önerilir.
                    </p>
                  </div>

                  <div>
                    <h5 className="font-semibold text-slate-900 mb-1">Pulse Width (Darbe Genişliği)</h5>
                    <p className="text-slate-700 text-sm leading-relaxed">
                      Kısa darbeler (3-10 ns): Yüksek çözünürlük, kısa mesafeler için<br />
                      Uzun darbeler (1-20 µs): Düşük gürültü, uzun mesafeler için<br />
                      Mesafe arttıkça darbe genişliği artırılmalıdır.
                    </p>
                  </div>

                  <div>
                    <h5 className="font-semibold text-slate-900 mb-1">Averaging Time (Ortalama Alma Süresi)</h5>
                    <p className="text-slate-700 text-sm leading-relaxed">
                      15 saniye - 3 dakika arası. Daha uzun süre daha temiz trace verir ancak test süresi uzar.
                    </p>
                  </div>

                  <div>
                    <h5 className="font-semibold text-slate-900 mb-1">Distance Range (Mesafe Aralığı)</h5>
                    <p className="text-slate-700 text-sm leading-relaxed">
                      Test edilecek fiber uzunluğuna göre ayarlanır. Fiber uzunluğunun 1.5-2 katı seçilmelidir.
                    </p>
                  </div>

                  <div>
                    <h5 className="font-semibold text-slate-900 mb-1">IOR (Index of Refraction - Kırılma İndisi)</h5>
                    <p className="text-slate-700 text-sm leading-relaxed">
                      Tipik değer: 1.4680-1.4685. Fiber üreticisinin belirttiği değer kullanılmalıdır. Yanlış IOR değeri mesafe hatalarına neden olur.
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR Testi Uygulama Alanları</h2>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-search-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Arıza Tespiti</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Fiber kablo kesikleri, kırıkları ve hasar noktalarının tam konumunun belirlenmesi. <Link to="/fiber-hizmetleri/fiber-kablo-tamiri" className="text-teal-600 hover:text-teal-700 font-semibold">Acil tamir</Link> için kritik bilgi sağlar.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-flashlight-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Ek Kalitesi Kontrolü</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="text-teal-600 hover:text-teal-700 font-semibold">Fusion splicing</Link> sonrası ek kalitesinin ölçülmesi ve kayıp değerlerinin doğrulanması.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-building-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Yeni Kurulum Testi</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    <Link to="/fiber-hizmetleri/bina-fiber" className="text-teal-600 hover:text-teal-700 font-semibold">Bina</Link> ve <Link to="/fiber-hizmetleri/fabrika-fiber" className="text-teal-600 hover:text-teal-700 font-semibold">fabrika fiber altyapı</Link> kurulumu sonrası sistem performansının doğrulanması.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-file-chart-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Dokümantasyon</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Fiber altyapının mevcut durumunun belgelenmesi, gelecekteki karşılaştırmalar için referans oluşturulması.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-tools-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Periyodik Bakım</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Fiber performansinin düzenli olarak izlenmesi, potansiyel sorunların erken tespiti.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Kabul Testi</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Yüklenici tarafından tamamlanan fiber kurulumunun spesifikasyonlara uygunluğunun doğrulanması.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR vs Diğer Test Yöntemleri</h2>

              <div className="overflow-x-auto mb-8">
                <table className="w-full border-collapse bg-white rounded-xl overflow-hidden shadow-lg">
                  <thead>
                    <tr className="bg-slate-900 text-white">
                      <th className="p-4 text-left font-semibold">Test Yöntemi</th>
                      <th className="p-4 text-left font-semibold">Avantajlar</th>
                      <th className="p-4 text-left font-semibold">Dezavantajlar</th>
                      <th className="p-4 text-left font-semibold">Kullanım Alanı</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    <tr className="border-b border-slate-200">
                      <td className="p-4 font-semibold text-slate-900">OTDR</td>
                      <td className="p-4 text-slate-700">
                        • Tek uçtan test<br />
                        • Arıza konumu tespit<br />
                        • Detaylı analiz<br />
                        • Tüm fiber haritası
                      </td>
                      <td className="p-4 text-slate-700">
                        • Pahalı cihaz<br />
                        • Uzmanlık gerektirir<br />
                        • Test süresi uzun
                      </td>
                      <td className="p-4 text-slate-700">
                        Arıza tespiti, kurulum sonrası test, dokümantasyon
                      </td>
                    </tr>
                    <tr className="border-b border-slate-200 bg-slate-50">
                      <td className="p-4 font-semibold text-slate-900">Light Source & Power Meter</td>
                      <td className="p-4 text-slate-700">
                        • Basit kullanım<br />
                        • Hızlı test<br />
                        • Ekonomik<br />
                        • Doğru kayıp ölçümü
                      </td>
                      <td className="p-4 text-slate-700">
                        • İki uç gerekli<br />
                        • Arıza konumu yok<br />
                        • Detay yok
                      </td>
                      <td className="p-4 text-slate-700">
                        Basit kayıp ölçümü, kısa linkler, hızlı doğrulama
                      </td>
                    </tr>
                    <tr className="border-b border-slate-200">
                      <td className="p-4 font-semibold text-slate-900">Visual Fault Locator (VFL)</td>
                      <td className="p-4 text-slate-700">
                        • Çok basit<br />
                        • Anında sonuç<br />
                        • Çok ucuz<br />
                        • Görsel tespit
                      </td>
                      <td className="p-4 text-slate-700">
                        • Sadece 5 km'ye kadar<br />
                        • Kaba tespit<br />
                        • Ölçüm yok
                      </td>
                      <td className="p-4 text-slate-700">
                        Kısa mesafe arıza, fiber tanımlama, konnektör kontrolü
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-lightbulb-line text-amber-600 text-2xl mt-1"></i>
                  <div>
                    <h4 className="font-bold text-amber-900 mb-2">Profesyonel Öneri:</h4>
                    <p className="text-amber-800 leading-relaxed">
                      En iyi sonuç için OTDR testi ile birlikte Light Source & Power Meter testi de yapılmalıdır. OTDR tek yönlü ölçüm yaparken, LS&PM çift yönlü ölçüm yaparak daha doğru toplam kayıp değeri verir.
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OTDR Test Raporu Neleri İçermeli?</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                Profesyonel bir OTDR test raporu şu bilgileri içermelidir:
              </p>

              <div className="bg-slate-50 p-6 rounded-xl mb-8 border border-slate-200">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Proje Bilgileri:</strong> Lokasyon, tarih, test eden kişi, cihaz modeli</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Fiber Özellikleri:</strong> Fiber tipi (SM/MM), kablo tipi, fiber sayısı</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Test Parametreleri:</strong> Dalga boyu, pulse width, IOR, averaging time</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>OTDR Trace Grafiği:</strong> Her iki yön ve her dalga boyu için</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Event Tablosu:</strong> Tüm ek, konnektör ve olayların listesi</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Toplam Kayıp:</strong> End-to-end insertion loss (dB)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Fiber Uzunluğu:</strong> Metre cinsinden toplam uzunluk</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Pass/Fail Durumu:</strong> Spesifikasyonlara uygunluk</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Notlar ve Yorumlar:</strong> Tespit edilen sorunlar ve öneriler</span>
                  </li>
                </ul>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sanayi Tesislerinde OTDR Testi Önemi</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                <Link to="/bolgeler/gebze" className="text-teal-600 hover:text-teal-700 font-semibold">Gebze</Link>, <Link to="/bolgeler/tuzla" className="text-teal-600 hover:text-teal-700 font-semibold">Tuzla</Link>, <Link to="/bolgeler/kocaeli" className="text-teal-600 hover:text-teal-700 font-semibold">Kocaeli</Link> gibi sanayi bölgelerindeki fabrikalarda fiber optik altyapı, üretim süreçlerinin omurgasıdır. OTDR testi ile:
              </p>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-time-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Kesinti Süresi Azalır</h4>
                  <p className="text-slate-600 text-sm">
                    Arıza noktası hızla tespit edilir, tamir süresi minimize edilir
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Önleyici Bakım</h4>
                  <p className="text-slate-600 text-sm">
                    Potansiyel sorunlar arıza olmadan tespit edilir
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-file-chart-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Dokümantasyon</h4>
                  <p className="text-slate-600 text-sm">
                    Fiber altyapı tam olarak belgelenir, gelecek için referans oluşur
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sık Sorulan Sorular</h2>

              <div className="space-y-4 mb-12">
                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>OTDR testi ne kadar sürer?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Test süresi fiber uzunluğuna ve seçilen parametrelere bağlıdır. Kısa bir fiber linki (1-2 km) için 5-10 dakika, uzun mesafeli linkler (20-50 km) için 15-30 dakika sürebilir. Her iki yön ve her dalga boyunda test yapılması önerilir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>OTDR testi için fiber trafiği kesilmeli mi?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Evet, OTDR testi sırasında fiber üzerinde aktif trafik olmamalıdır. OTDR yüksek güçlü ışık darbeleri gönderdiği için aktif ekipmanlar zarar görebilir. Test öncesi fiber bağlantıları kesilmeli veya bakım penceresi planlanmalıdır.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>OTDR testi hangi dalga boyunda yapılmalı?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Single mode fiberler için hem 1310 nm hem de 1550 nm dalga boyunda test yapılması önerilir. 1310 nm kısa mesafeler için, 1550 nm uzun mesafeler için daha uygundur. Multi mode fiberler için 850 nm ve 1300 nm kullanılır. Her dalga boyunda farklı sonuçlar alınabilir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>OTDR ile hangi mesafeye kadar test yapılabilir?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    OTDR cihazının dynamic range değerine bağlıdır. Tipik bir OTDR 30-40 dB dynamic range ile 40-60 km mesafeye kadar test yapabilir. Yüksek performanslı OTDR'ler 45-50 dB ile 100+ km mesafeleri test edebilir. Kısa mesafeler (100 m altı) için özel kısa mesafe OTDR'ler gerekir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>OTDR testi sonrası rapor verilir mi?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Evet, profesyonel OTDR test hizmetimizde detaylı test raporu verilir. Rapor OTDR trace grafikleri, event tablosu, toplam kayıp değerleri, fiber uzunluğu ve pass/fail durumunu içerir. Raporlar PDF formatında teslim edilir ve arşivlenebilir.
                  </p>
                </details>
              </div>

            </div>

            {/* CTA Section */}
            <div className="mt-16 p-8 bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl text-center">
              <h3 className="text-3xl font-bold text-white mb-4">
                Profesyonel OTDR Test Hizmeti
              </h3>
              <p className="text-slate-300 text-lg mb-6">
                Sertifikalı teknisyenlerimiz ve son teknoloji OTDR cihazlarımızla hizmetinizdeyiz
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:+905537165561"
                  className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/50 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  +90 553 716 55 61
                </a>
                <a
                  href="https://wa.me/908505551234"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-white hover:bg-slate-50 text-slate-900 font-semibold rounded-xl transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp Destek
                </a>
              </div>
            </div>

            {/* İlgili Hizmetler */}
            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Hizmetlerimiz</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Link to="/fiber-hizmetleri/otdr-test" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">OTDR Test Hizmeti</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Profesyonel fiber optik test ve analiz</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-kablo-tamiri" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-tools-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fiber Kablo Tamiri</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Arıza sonrası profesyonel onarım</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-flashlight-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fusion Splicing & Sonlandırma</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Fiber ek ve konnektör işlemleri</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fabrika-fiber" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-building-2-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fabrika Fiber Altyapı</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Endüstriyel fiber optik kurulum</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
              </div>
            </div>

            {/* Related Articles */}
            <div className="mt-16">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Makaleler</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <Link to="/blog/fiber-optik-kablo-tamiri-nasil-yapilir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-tools-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fiber Kablo Tamiri</h4>
                    <p className="text-slate-600 text-sm">Profesyonel fiber optik kablo tamir rehberi</p>
                  </div>
                </Link>

                <Link to="/blog/fusion-splicing-nedir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-flashlight-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fusion Splicing</h4>
                    <p className="text-slate-600 text-sm">Fiber optik kaynaklı ek teknolojisi</p>
                  </div>
                </Link>

                <Link to="/blog/sanayi-bolgelerinde-fiber-altyapi-onemi" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-building-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">OSB Fiber Altyapı</h4>
                    <p className="text-slate-600 text-sm">Sanayi bölgelerinde fiber optik önemi</p>
                  </div>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}